import { formatNumber } from "@/v2-common/utils/utils.formatting"
import { formatMunicipalityName } from "@/v2-backoffice-client/usage/usage.constants"

type UsageGeoAreaEntry = {
  Code: string
  Name: string
  Count: number
  Pct: number
}

export type UsageGeoAreasProps = {
  areas: UsageGeoAreaEntry[]
}

/**
 * Top municipalities of geographic interest as share bars — where the
 * tracked work happens (event coordinates resolved to municipalities by the
 * usage pipeline). Pct is each municipality's share of all
 * location-carrying events, so bars are comparable across users and scopes.
 */
function UsageGeoAreas(props: UsageGeoAreasProps) {
  const { areas } = props

  return (
    <ul className="flex flex-col gap-1.5">
      {areas.map((area) => (
        <li key={area.Code} className="flex items-center gap-2">
          <span className="w-32 shrink-0 truncate text-xs">
            {formatMunicipalityName(area.Name)}
          </span>
          <span className="h-2 min-w-8 flex-1 overflow-hidden rounded-full bg-muted">
            <span
              className="usage-history-strip-cell-high block h-full rounded-full"
              style={{ width: `${Math.min(area.Pct, 100)}%` }}
            />
          </span>
          <span className="w-20 shrink-0 text-right text-xs tabular-nums text-muted-foreground">
            {area.Pct.toFixed(0)}% · {formatNumber(area.Count)}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default UsageGeoAreas
